import { BADGE_LEVELS, BADGE_IMAGE } from '../../services/badging/constants';
import { formatLocale_UpperCaseUnderscore } from '../../services/locale';

export const sortBadgesByLevelDesc = (badges) => {
  badges.sort((a, b) => {
    const badgeLevelIndexA = BADGE_LEVELS.findIndex((x) => x === a.rewardLevelId);
    const badgeLevelIndexB = BADGE_LEVELS.findIndex((x) => x === b.rewardLevelId);
    return badgeLevelIndexB - badgeLevelIndexA;
  });
  return badges;
};

/**
 * Badge artwork keyed by locale. Use this instead of indexing BADGE_IMAGE directly: callers pass
 * either a badge's locale ("ES_MX") or a session locale ("es-mx"), and an unrecognized or missing
 * locale falls back to English artwork rather than throwing. One place to update if a third locale lands.
 */
export const getBadgeImage = (locale, rewardLevelId) =>
  (BADGE_IMAGE[formatLocale_UpperCaseUnderscore(locale)] || BADGE_IMAGE.EN_US)[rewardLevelId];
